/* eslint-disable */
// @ts-nocheck
import type { PreviewDevice } from '../../../types/journeyTypes';

/*
WHERE DO THESE HARD-CODED VALUES COME FROM?

width/height: The width and height of the viewport for each type of device
              can be found easily online with a Google search (common knowledge).
    NOTE: Resolution is what you will usually find online, but what we care
          about it actually the viewport size.

    Resolution
    -----------------  =  Viewport (what we care about)
    Pixel Ratio


    Resolution: How many pixels are displayed on the screen, usually the stats you
                see listed about a given phone.

    Viewport: The width and height of the CSS pixels displayed on the screen.

    Pixel Ratio: How many screen pixels equals one CSS pixel.

    More details: https://medium.com/@flik185/understanding-device-resolution-for-web-design-and-development-3bb4a5183478

padding: These are each manually calculated depending on the exact image asset
         for the outline which Design has provided us.
    NOTE: We are leaving intentional space at the top/bottom of each device
          screen opening to account for browser/operating system navigation.
    - 'top'/'left' are used to determine where the Journey preview should start
      in relation to the outline image
    - 'bottom' is used to determine the correct height the preview iFrame should
      take up (total height minus bottom padding, see ScreenViewEditor)

backgroundSize: Again this is manually calculated depending on the exact image
                asset for the outline which Design has provided us.
                This sets the 'background-size' property, determining the width
                of the device outline image (when one number is passed to
                'background-size' is it dictating the width, and the height is
                calculated).
*/
const STANDARD_LEFT_PADDING = 18;
export const DEVICE_OUTLINES: Record<string, PreviewDevice> = {
  iPhoneX_XS: {
    width: 375,
    height: 812,
    padding: {
      top: 109,
      left: STANDARD_LEFT_PADDING,
      bottom: 150,
    },
    backgroundSize: 308,
    outlineImage: 'iPhoneX_XS.svg',
  },
  iPhoneXR_XSMAX: {
    width: 414,
    height: 896,
    padding: {
      top: 109,
      left: STANDARD_LEFT_PADDING,
      bottom: 150,
    },
    backgroundSize: 340,
    outlineImage: 'iPhoneXR_XSMAX.svg',
  },
  iPhone6_7_8: {
    width: 375,
    height: 666.667,
    padding: {
      top: 130,
      left: 28,
      bottom: 115,
    },
    backgroundSize: 330,
    outlineImage: 'iPhone6_7_8.svg',
  },
  iPhone6_7_8_Plus: {
    width: 414,
    height: 736,
    padding: {
      top: 135,
      left: 30,
      bottom: 115,
    },
    backgroundSize: 367,
    outlineImage: 'iPhone6+_7+_8+.svg',
  },
  iPhone5: {
    width: 320,
    height: 568,
    padding: {
      top: 120,
      left: 26,
      bottom: 120,
    },
    backgroundSize: 303,
    outlineImage: 'iPhone5.svg',
  },
  iPhone4: {
    // Unfortunately there are weird CSS consequences to the background View
    // Editor controls if a backgroundSize is below 300. iPhone4 ideally would
    // have 289 background size with the expected 320 width, but to correct
    // for this I am artificially scaling this one bigger with the + 13 and + 20
    width: 320 + 13,
    height: 480 + 20,
    padding: {
      top: 105,
      left: 26,
      bottom: 115,
    },
    backgroundSize: 300,
    outlineImage: 'iPhone4.svg',
  },
  HuaweiP30: {
    width: 360,
    height: 810,
    padding: {
      top: 90,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 300,
    outlineImage: 'HuaweiP30.svg',
  },
  HuaweiMate20: {
    width: 360,
    height: 748,
    padding: {
      top: 80,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 300,
    outlineImage: 'HuaweiMate20.svg',
  },
  GalaxyS10: {
    width: 360,
    height: 760,
    padding: {
      top: 95,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 304,
    outlineImage: 'GalaxyS10.svg',
  },
  GalaxyS10plus: {
    width: 412,
    height: 869,
    padding: {
      top: 95,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 335,
    outlineImage: 'GalaxyS10+.svg',
  },
  GalaxyS8_S8Plus_S9_S9Plus: {
    width: 360,
    height: 740,
    padding: {
      top: 110,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 300,
    outlineImage: 'GalaxyS8_S8+_S9_S9+.svg',
  },
  GalaxyS5_S6_S6Plus_S7_S7Plus: {
    width: 360,
    height: 640,
    padding: {
      top: 115,
      left: STANDARD_LEFT_PADDING,
      bottom: 105,
    },
    backgroundSize: 300,
    outlineImage: 'GalaxyS5_S6_S6+_S7_S7+.svg',
  },
  GooglePixel3: {
    width: 412,
    height: 824,
    padding: {
      top: 125,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 340,
    outlineImage: 'GooglePixel3.svg',
  },
  GooglePixel3XL: {
    width: 412,
    height: 847,
    padding: {
      top: 120,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 340,
    outlineImage: 'GooglePixel3XL.svg',
  },
  GooglePixel2: {
    width: 412,
    height: 732,
    padding: {
      top: 138,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 340,
    outlineImage: 'GooglePixel2.svg',
  },
};
export default [
  {
    value: 'iphoneX',
    label: 'iPhone X',
    ...DEVICE_OUTLINES.iPhoneX_XS,
  },
  {
    value: 'iphoneXS',
    label: 'iPhone XS',
    ...DEVICE_OUTLINES.iPhoneX_XS,
  },
  {
    value: 'iphoneXSMax',
    label: 'iPhone XS Max',
    ...DEVICE_OUTLINES.iPhoneXR_XSMAX,
  },
  {
    value: 'iphoneXR',
    label: 'iPhone XR',
    ...DEVICE_OUTLINES.iPhoneXR_XSMAX,
  },
  {
    value: 'iphone8',
    label: 'iPhone 8',
    ...DEVICE_OUTLINES.iPhone6_7_8,
  },
  {
    value: 'iphone8+',
    label: 'iPhone 8 Plus',
    ...DEVICE_OUTLINES.iPhone6_7_8_Plus,
  },
  {
    value: 'iphone7',
    label: 'iPhone 7',
    ...DEVICE_OUTLINES.iPhone6_7_8,
  },
  {
    value: 'iphone7+',
    label: 'iPhone 7 Plus',
    ...DEVICE_OUTLINES.iPhone6_7_8_Plus,
  },
  {
    value: 'iphone6',
    label: 'iPhone 6',
    ...DEVICE_OUTLINES.iPhone6_7_8,
  },
  {
    value: 'iphone6+',
    label: 'iPhone 6 Plus',
    ...DEVICE_OUTLINES.iPhone6_7_8_Plus,
  },
  {
    value: 'iphone5',
    label: 'iPhone 5',
    ...DEVICE_OUTLINES.iPhone5,
  },
  {
    value: 'iphone4',
    label: 'iPhone 4',
    ...DEVICE_OUTLINES.iPhone4,
  },
  {
    value: 'huaweiP30',
    label: 'Huawei P30',
    ...DEVICE_OUTLINES.HuaweiP30,
  },
  {
    value: 'huaweiP30pro',
    label: 'Huawei P30 Pro',
    ...DEVICE_OUTLINES.HuaweiP30,
  },
  {
    value: 'huaweiMate20',
    label: 'Huawei Mate 20',
    ...DEVICE_OUTLINES.HuaweiMate20,
  },
  {
    value: 'huaweiMate20Pro',
    label: 'Huawei Mate 20 Pro',
    ...DEVICE_OUTLINES.HuaweiMate20,
  },
  {
    value: 'galaxyS10',
    label: 'Samsung Galaxy S10',
    ...DEVICE_OUTLINES.GalaxyS10,
  },
  {
    value: 'galaxyS10+',
    label: 'Samsung Galaxy S10+',
    ...DEVICE_OUTLINES.GalaxyS10plus,
  },
  {
    value: 'galaxyS9',
    label: 'Samsung Galaxy S9',
    ...DEVICE_OUTLINES.GalaxyS8_S8Plus_S9_S9Plus,
  },
  {
    value: 'galaxyS9+',
    label: 'Samsung Galaxy S9+',
    ...DEVICE_OUTLINES.GalaxyS8_S8Plus_S9_S9Plus,
  },
  {
    value: 'galaxyS8',
    label: 'Samsung Galaxy S8',
    ...DEVICE_OUTLINES.GalaxyS8_S8Plus_S9_S9Plus,
  },
  {
    value: 'galaxyS8+',
    label: 'Samsung Galaxy S8+',
    ...DEVICE_OUTLINES.GalaxyS8_S8Plus_S9_S9Plus,
  },
  {
    value: 'galaxyS7',
    label: 'Samsung Galaxy S7',
    ...DEVICE_OUTLINES.GalaxyS5_S6_S6Plus_S7_S7Plus,
  },
  {
    value: 'galaxyS7+',
    label: 'Samsung Galaxy S7+',
    ...DEVICE_OUTLINES.GalaxyS5_S6_S6Plus_S7_S7Plus,
  },
  {
    value: 'galaxyS6',
    label: 'Samsung Galaxy S6',
    ...DEVICE_OUTLINES.GalaxyS5_S6_S6Plus_S7_S7Plus,
  },
  {
    value: 'galaxyS6+',
    label: 'Samsung Galaxy S6+',
    ...DEVICE_OUTLINES.GalaxyS5_S6_S6Plus_S7_S7Plus,
  },
  {
    value: 'galaxyS5',
    label: 'Samsung Galaxy S5',
    ...DEVICE_OUTLINES.GalaxyS5_S6_S6Plus_S7_S7Plus,
  },
  {
    value: 'pixel3',
    label: 'Google Pixel 3',
    ...DEVICE_OUTLINES.GooglePixel3,
  },
  {
    value: 'pixel3XL',
    label: 'Google Pixel 3 XL',
    ...DEVICE_OUTLINES.GooglePixel3XL,
  },
  {
    value: 'pixel2',
    label: 'Google Pixel 2',
    ...DEVICE_OUTLINES.GooglePixel2,
  },
  {
    value: 'pixel2XL',
    label: 'Google Pixel 2 XL',
    ...DEVICE_OUTLINES.GooglePixel2,
  },
  {
    value: 'pixel',
    label: 'Google Pixel',
    ...DEVICE_OUTLINES.GooglePixel2,
  },
  {
    value: 'pixelXL',
    label: 'Google Pixel XL',
    ...DEVICE_OUTLINES.GooglePixel2,
  },
];
